import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { toast } from 'react-toastify';
import './productsdetails.css';
import { Products } from '../../appojo/models/Products';

import {
    requestApi, RequestModel, ResponseModel,
    EndPointPaths, printConsole, AssetConstants,
    RouteConstants, SessionKeys, clientConfig,
    i18n, strings, checkLoginData
} from '../../utils/CommonImports';
import { CartRequest } from '../../appojo/requestmodel/CartRequest';

const ProductDetailsScreen = (props: any) => {
    let navigate = useNavigate();
    const [stateValue, setStateValue] = useState({
        languageName: '',
        users: null,
        productObj: new Products(),
        previousMenu: RouteConstants.DashBoard,
    });
    const [showLoader, setShowLoader] = useState(false);
    const [cartQuantity, setCartQuantity] = useState(props.cartQuantity != null ? props.cartQuantity : 0);
    const [isConnected, setIsConnected] = useState(true);
    const [initialState, setInitialState] = useState(true);
    const [dummyData, setDummyData] = useState(true);
    // const [similarProducts, setSimilarProducts] = useState(new Products());
    const [similarProducts, setSimilarProducts] = useState<Products[]>([]);

    useEffect(() => {
        getSessionValues()
            .then((productObj) => {


                if (productObj != null) {
                    getSimilarProducts(productObj);
                } else {
                    getSimilarProducts(productObj);
                }
                setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                }, 0)
            });

        return () => {

        }
    }, [props]);


    const getSessionValues = async () => {
        let users = JSON.parse(sessionStorage.getItem(SessionKeys.loginObj));
        let productObj = JSON.parse(sessionStorage.getItem(SessionKeys.productObj));
        console.log('product: ', JSON.stringify(productObj))
        let previousMenu = sessionStorage.getItem(SessionKeys.previousMenu);
        let language = sessionStorage.getItem(SessionKeys.languageName);
        if (language == null) {
            language = clientConfig.defaultLanguage;
        }
        if (productObj != null) {
            imageClicked(productObj.productImageList[0]);
        }
        i18n.changeLanguage(language);
        stateValue.languageName = language;
        stateValue.productObj = productObj;
        stateValue.previousMenu = previousMenu;
        stateValue.users = users;
        setStateValue(stateValue);
        return productObj;
    }

    const getSimilarProducts = async (productObj: any) => {
        printConsole("product object: " + JSON.stringify(productObj))
        try {
            setShowLoader(true);
            const request = new RequestModel();
            request.userId = '809957651';
            request.reqObject = productObj;
            const responseResult = await requestApi(request, EndPointPaths.getproductsbygenderandproducttype, isConnected);
            if (responseResult.status === 0) {
                const responsemodel: ResponseModel = responseResult.data;
                if (responsemodel.statusCode === 0) {
                    setSimilarProducts(responsemodel.respList);
                    setInitialState(false);
                } else if (responsemodel.statusCode === 1) {
                    toast(strings(responsemodel.message));
                } else if (responsemodel.statusCode === 2) {
                    toast(strings(responsemodel.message));
                } else {
                    toast(strings('plsetry'));
                }
            } else {
                printConsole("API dash Error 3: " + responseResult.data)
            }
        } catch (err) {
            printConsole("Try Error dash: " + err);
        } finally {
            setShowLoader(false);
        }
    }

    const topListCloths = {
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        'responsive': [
            {
                'breakpoint': 1000,
                'settings': {
                    'slidesToShow': 5,
                    'slidesToScroll': 1,
                    centerPadding: '100px',
                }
            }, {
                'breakpoint': 600,
                'settings': {
                    'slidesToShow': 3,
                    'slidesToScroll': 1,
                    centerPadding: '50px',
                }
            },
            {
                'breakpoint': 550,
                'settings': {
                    'slidesToShow': 3,
                    'slidesToScroll': 1,
                    'centerMode': false,
                }
            },
            {
                'breakpoint': 400,
                'settings': {
                    'slidesToShow': 2,
                    'slidesToScroll': 1,
                    'centerMode': false,
                }
            },

        ],
    };
    const saveStorage = async (value: any, key: any, type: any) => {
        if (type === "object") {
            sessionStorage.setItem(key, JSON.stringify(value));
        } else if (type === "remove") {
            sessionStorage.removeItem(key);
        } else {
            sessionStorage.setItem(key, value)
        }
    }
    const viewCartClicked = () => {
        saveStorage(RouteConstants.DashBoard, SessionKeys.previousMenu, 'string');
        navigate("../viewcart");
    }

    const buyNowClicked = (productObj: Products) => {
        stateValue.productObj = productObj;
        setStateValue(stateValue);
        imageClicked(productObj.productImageList[0]);
        getSimilarProducts(productObj);
    }
    const [selectedImage, setSelectedImage] = useState('');
    const imageClicked = (imageUrl: string) => {
        setSelectedImage(imageUrl);
        setDummyData(!dummyData);
    }
    const calculatePercentage = (actualPrice: number, offerPrice: number) => {
        const differenceAmount = actualPrice - offerPrice;
        const percentage = differenceAmount / actualPrice * 100;
        return Math.round(percentage * Math.pow(10, 2)) / Math.pow(10, 2);;
    }
    const addtoCart = async () => {
        try {
            // console.log('login data: ' + JSON.stringify(stateValue.users))
            if (checkLoginData(stateValue.users)) {
                setShowLoader(true);
                const request = new RequestModel();
                const cartRequest = new CartRequest();
                cartRequest.userId = stateValue.users.id;
                cartRequest.productId = stateValue.productObj.id;
                cartRequest.quantity = 1;
                request.userId = '809957651';
                request.reqObject = cartRequest;
                const responseResult = await requestApi(request, EndPointPaths.addtocart, isConnected);
                if (responseResult.status === 0) {
                    const responsemodel: ResponseModel = responseResult.data;
                    if (responsemodel.statusCode === 0) {
                        setCartQuantity(responsemodel.respList.length);
                        toast(strings(responsemodel.message));
                    } else if (responsemodel.statusCode === 1 || responsemodel.statusCode === 2 || responsemodel.statusCode === 11) {
                        toast(strings(responsemodel.message));
                    } else {
                        toast('plsetry');
                    }
                } else if (responseResult.status === 1) {
                    printConsole("API dash Error 1: " + responseResult.data)
                    toast(strings('plsetry'));
                } else if (responseResult.status === 2) {
                    printConsole("API dash Error 2: " + responseResult.data)
                    toast(strings('plsetry'));

                } else {
                    printConsole("API dash Error 3: " + responseResult.data)
                    toast(strings('plsetry'));
                }
            } else {
                // saveStorage(RouteConstants.ProductDetailScreen, STORAGE_KEY.previousMenu, 'string');
                // props.navigation.navigate(RouteConstants.LoginScreen);
                document.getElementById("loginForm").style.display = "block";
                // toast(strings('plsetry'));
            }
        } catch (err) {
            printConsole("Try Error dash: " + err);
            // ToastMessage.showError(strings('plsetry'));
        } finally {
            setShowLoader(false);
        }
    }
    return (
        < >
            <section>
                {stateValue.productObj.id == null ? null :
                    <div className='container'>
                        <div className='row'>
                            <div className='col-sm-1'>
                                {stateValue.productObj?.productImageList.map((imageObj, index) => {
                                    return (
                                        <div key={index}>
                                            <div style={{ display: 'flex', justifyContent: "end" }}>
                                                <div className='mt-2' onClick={() => imageClicked(imageObj)} style={{ padding: '10px', border: '1px solid #ccc' }}>
                                                    <img alt="slider" style={{ height: '90px', width: '90px' }} onError={({ currentTarget }) => {
                                                        currentTarget.onerror = null;
                                                        currentTarget.src = AssetConstants.defaultimg;
                                                    }} src={imageObj} />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}

                            </div>
                            <div className='col-sm-4' >
                                <div className='mt-3 mb-3' style={{ display: 'flex' }}>
                                    <img alt="slider" style={{ height: 'auto', width: '100%' }} src={selectedImage} />
                                </div>
                            </div>
                            <div className='col-sm-7'>
                                <div className='mt-2'>
                                    <div style={{ padding: '5px 15px', backgroundColor: 'rgb(26, 25, 25)', color: 'white', borderRadius: '4px' }}>
                                        {stateValue.productObj.title}
                                    </div>

                                    <div className='mt-3'>
                                        <h6 style={{ color: '#388e3c', margin: '0', fontSize: '14px', fontWeight: '500' }}>Special Price</h6>
                                        <p style={{ fontSize: '28px', fontWeight: '500' }}>{clientConfig.currencySymbol}{stateValue.productObj.offerPrice}
                                            <span style={{ fontSize: '15px', textDecoration: 'line-through', color: '#aaa', fontWeight: '500' }}>{clientConfig.currencySymbol}{stateValue.productObj.actualPrice},
                                            </span> <span style={{ fontSize: '14px', color: '#388e3c', fontWeight: '500' }}>{calculatePercentage(stateValue.productObj.actualPrice, stateValue.productObj.offerPrice)}% off</span></p>
                                    </div>
                                    <div className='mt-2 ' style={{ display: 'flex', alignItems: 'center' }}>
                                        <span className='rating ' style={{ fontSize: '14px' }}>{stateValue.productObj.ratingAverage}&nbsp;<label style={{ fontSize: '11px' }} className='fa fa-star'></label></span>
                                        {/* <span>&nbsp; 15,008 ratings and 1,332 reviews</span> */}
                                    </div>
                                    {/* <div className='mt-2'>
                                        <h6>Deposit Amount</h6>
                                        <p>XAF 2000  </p>
                                    </div> */}

                                    <div className='mt-2' style={{ padding: '6px 10px', border: '1px solid #ccc', borderRadius: '4px' }}>
                                        <div style={{ borderBottom: '1px solid #bbb' }}>
                                            <h6>Description</h6>
                                        </div>
                                        <div >
                                            <p>{stateValue.productObj.description}</p>
                                        </div>
                                        <div className='mt-4' style={{ borderBottom: '1px solid #bbb' }}>
                                            <h6>Product Code</h6>
                                        </div>
                                        <div >
                                            <p>{stateValue.productObj.productCode}</p>
                                        </div>
                                    </div>
                                    <div className='mt-2'>
                                        <button className='addtoCart' onClick={() => addtoCart()}>Add to cart</button>
                                        <a onClick={() => viewCartClicked()} ><button className='addtoCart'>View Cart</button></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

            </section>

            {/* slider */}
            <section className='mt-2 pt-4' style={{ height: "auto", width: "100%", backgroundColor: '#eee' }}>
                <div className='container-fluid'>
                    <div >
                        <h4 className='pt-2'>You might be interested in</h4>
                    </div>
                    <Slider {...topListCloths} >
                        {similarProducts.map((clientObj, index) => {
                            return (
                                <div key={index} >
                                    <div className="eventsBox">
                                        <div className="box">
                                            <img alt="box" className='boxImage' onError={({ currentTarget }) => {
                                                currentTarget.onerror = null;
                                                currentTarget.src = AssetConstants.defaultimg;
                                            }} src={clientObj.productThumbNailImage} />
                                            <div className="content">
                                                <div className="wrap">
                                                    <button className='button' onClick={() => buyNowClicked(clientObj)}>Buy Now</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <h6 className='oneLineText'>{clientObj.title}</h6>
                                            <p className='oneLineText'>{clientObj.shortDescription}</p>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </Slider>
                </div>
            </section>
            {/* slider */}

        </>
    )
}
export default ProductDetailsScreen;